export const getPrizeSuffixTranslationKey = ({ prizeCode }: { prizeCode?: string }) => {
  const translationKeyMap: Record<string, string> = {
    betcredit: 'prize-board-bet-credit-prize',
    freespin: 'free-spins',
  };
  return translationKeyMap[prizeCode ?? ''] || '';
};

export const getPrizeCodeClassModifier = ({ prizeCode }: { prizeCode?: string }) =>
  prizeCode && ['freespin', 'betcredit'].includes(prizeCode) ? '--non-cash-prize' : '';
